import Paper from './Paper'
import PaperWrapper from './PaperWrapper'
import AreaOfSymbols from './AreaOfSymbols'
import InsertSyllable from './InsertSyllable'
import EditSyllable from './EditSyllable'
import RemovePageButton from './RemovePageButton'
import EditText from './EditText'
import ButtonRemove from './ButtonRemove'
import CurrentSymbols from './CurrentSymbols'
import EditButtons from './EditButtons'
import InsertComposition from './InsertComposition'
import InsertText from './InsertText'
import PaperStyle from './PaperStyle'
import RemoveParagraphButton from './RemoveParagraphButton'
import RemoveParagraph from './RemoveParagraph'
import RemovePageModal from './RemovePageModal'

export {
  Paper,
  PaperWrapper,
  AreaOfSymbols,
  InsertSyllable,
  EditSyllable,
  RemovePageButton,
  EditText,
  ButtonRemove,
  CurrentSymbols,
  EditButtons,
  InsertComposition,
  InsertText,
  PaperStyle,
  RemoveParagraphButton,
  RemoveParagraph,
  RemovePageModal,
}



// WEBPACK FOOTER //
// ./src/components/index.js